import React from "react";
import { styles } from "./styleProgressBar";

function ProgressBar({ progress }) {
  const total = Number(progress?.total ?? 0);
  const confirmados = Number(progress?.confirmados ?? 0);

  const percentage =
    total > 0 ? (confirmados / total) * 100 : 0;

  const safePercentage = Math.min(Math.max(percentage, 0), 100);

  // 🎨 Definir cor automática
  const getProgressColor = () => {
    if (safePercentage <= 30) return "var(--danger)"; // vermelho
    if (safePercentage <= 70) return "var(--warning)"; // amarelo
    return "var(--success)"; // verde
  };

  return (
    <div style={styles.containerPrincipal}>
      <h4 style={styles.textoContainer}>
        Arquivos preenchidos: {confirmados} de {total}
      </h4>

      <div style={styles.barraExterna}>
        {/* Barra preenchida */}
        <div
          style={{
            ...styles.barraInterna,
            width: `${safePercentage}%`,
            background: getProgressColor(),
          }}
        />

        {/* Texto centralizado */}
        <div style={styles.textoCentral}>
          {safePercentage.toFixed(2)}%
        </div>
      </div>
    </div>
  );
}

export default ProgressBar;